import { render, staticRenderFns } from "./AccountSectionCard.vue?vue&type=template&id=27154dc8&scoped=true"
import script from "./AccountSectionCard.vue?vue&type=script&lang=js"
export * from "./AccountSectionCard.vue?vue&type=script&lang=js"
import style0 from "./AccountSectionCard.vue?vue&type=style&index=0&id=27154dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27154dc8",
  null
  
)

export default component.exports